import { render, staticRenderFns } from "./VuesticMultiSelect.vue?vue&type=template&id=4898bffe&scoped=true"
import script from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
export * from "./VuesticMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticMultiSelect.vue?vue&type=style&index=0&id=4898bffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898bffe",
  null
  
)

export default component.exports